import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiAward, FiUsers, FiStar, FiPhone } from 'react-icons/fi';

const AboutSection = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center md:px-8 gap-12 px-4">
        <div className="w-full md:w-1/2 relative">
          <motion.div
            className="flex items-center min-w-[180px] absolute -top-3 md:top-10 left-0 gap-4 bg-white shadow-xl px-4 py-2 rounded-xl z-10"
            initial={{ y: 0 }}
            animate={{ y: 30 }}
            transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
          >
            <div className="p-2 bg-blue-50 rounded-lg">
              <FiStar className="w-6 h-6 text-amber-500" />
            </div>
            <div>
              <p className="font-semibold text-gray-800">125+</p>
              <p className="text-sm text-gray-600">Google Reviews</p>
            </div>
          </motion.div>

          <motion.div
            className="flex items-center min-w-[200px] absolute -bottom-3 md:bottom-14 right-0 gap-4 bg-white shadow-xl px-4 py-2 rounded-xl z-10"
            initial={{ y: 0 }}
            animate={{ y: -30 }}
            transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
          >
            <div className="p-2 bg-purple-50 rounded-lg">
              <FiUsers className="w-6 h-6 text-purple-500" />
            </div>
            <div>
              <p className="font-semibold text-gray-800">5000+</p>
              <p className="text-sm text-gray-600">Happy Celebrations</p>
            </div>
          </motion.div>

          <motion.div
            className="relative rounded-2xl overflow-hidden shadow-2xl"
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src="/images/image9.jpeg"
              alt="About Theatre"
              className="w-full h-auto rounded-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
          </motion.div>
        </div>

        <motion.div
          className="w-full md:w-1/2 space-y-6 py-3"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div>
            <motion.h2
              className="text-3xl md:text-4xl font-bold text-gray-800 mb-3"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Happy Bubble
            </motion.h2>
            <div className="h-1 w-20 bg-amber-500 rounded-full"></div>
          </div>

          <motion.p
            className="text-lg font-medium text-gray-700"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Choose the occasion, give us the requirements and leave it to us. We will deliver the best.
          </motion.p>

          <motion.div
            className="space-y-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <div className="flex items-start gap-3">
              <div className="p-2 bg-amber-50 rounded-lg mt-1">
                <FiAward className="w-5 h-5 text-amber-500" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-1">Premium Experience</h3>
                <p className="text-gray-600">150" screen with Dolby Atmos audio system, plush recliners, and premium amenities for the ultimate cinematic experience.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="p-2 bg-blue-50 rounded-lg mt-1">
                <FiUsers className="w-5 h-5 text-blue-500" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-1">Customized Celebrations</h3>
                <p className="text-gray-600">Perfect for birthdays, anniversaries, proposals, and special occasions with customized decorations and themes.</p>
              </div>
            </div>
          </motion.div>

          <motion.p
            className="text-gray-600 leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            Our private theater offers a unique blend of luxury and comfort, making every moment memorable. From romantic dates to family gatherings, we cater to all your entertainment needs with personalized service.
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 items-start sm:items-center mt-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <Link to="/about">
              <button className="px-6 py-3 bg-gray-800 text-white rounded-full hover:bg-gray-700 transition-colors flex items-center gap-2">
                Explore More
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </Link>
            <div className="flex items-center gap-2 text-gray-600">
              <FiPhone className="w-5 h-5 text-amber-500" />
              <span className="font-medium">+91 9880346464, +91 9986713636</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection; 